import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';


/* import { LoginRoutes } from './login'; */
import { SelectedPickingContextProvider } from 'contexts/SelectedPickingContext';
import { AgendamentoFob } from '../pages/AgendamentoFob';
import { AgendamentoFobSchedule } from '../pages/AgendamentoFob/Schedule';
import { AgendamentoFobConfirmation } from '../pages/AgendamentoFob/Confirmation';


export const Routes: React.FC = () => {
  return (
    <>
      {/* <LoginRoutes /> */}
      <SelectedPickingContextProvider>
        <Switch>
          <Redirect exact from="/" to="/agendamento-fob" />
          <Route path="/agendamento-fob" exact component={AgendamentoFob} />
          <Route path="/agendamento-fob/schedule" exact component={AgendamentoFobSchedule} />
          <Route path="/agendamento-fob/confirmation" exact component={AgendamentoFobConfirmation} />
          <Route path="/agendamento-fob/confirmation/:schedulingId" exact component={AgendamentoFobConfirmation} />
          <Redirect to="/agendamento-fob" />
        </Switch>
      </SelectedPickingContextProvider>
    </>
  );
};
